import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import Typography from '@mui/material/Typography';

import AcaoMenu from "../../Components/AcaoMenu";
import { ApplicationState } from "../../store";

import * as T1Actions from '../../store/ducks/t1/actions'
import T1TableComponent from "../../Components/TableT1";
import ModalCadastroT1 from "../../Components/ModalCadastroT1";
import Loading from "../../Components/LoadingComponent";
import AlertaConfirmaAcao from "../../Components/AlertaConfirmaAcao";
import { EntidadesAcoes } from "../../config/enums/EntidadesAcoesConfirmacao";

const _body = {
    pagina: 0,
    tamanho: 10,
    ordem: "ASC",
    coluna: "nmCursoT1",
    txtBusca: ""
};

function Treinamento1Ponto({
    t1,
    utils,
    getT1Table,
    onInativarT1,
    getT1Data,
    onSaveT1,
    onUpdateT1,
    onNotificacaoT1,
    clearT1Data
}: any) {

    const [idsSelecionado, setIdSelecionado] = useState<number[]>([]);
    const [modalCadastroOpen, setModalCadastroOpen] = useState(false);
    const [body, setBody] = useState(_body);
    const [table, setTable] = useState(null);
    const [alertConfirmacaoOpen, setAlertConfirmacaoOpen] = useState(false);
    const [alertConfirmacaoTexto, setAlertConfirmacaoTexto] = useState('');
    const [alertConfirmacaoAcao, setAlertConfirmacaoAcao] = useState(() => () => {});

    useEffect(() => {
        if(t1.error){
            alert('Erro!\nAtenção, ocorreu um erro durante sua solicitação. Caso apareça essa mensagem novamente procure o Suporte:\nDescrição do erro: ' + t1.errorMessage);
        }
    }, [t1.error]);

    useEffect(() => {
        if(!t1.loadingPersis) {
            handleCloseAndReload()
        }
    }, [t1.loadingPersis]);

    useEffect(() => {
        if(!modalCadastroOpen) {
            getT1TableData();
        }
    }, [body, modalCadastroOpen]);

    useEffect(() => {
        if(t1.data.table != null){
            setTable(t1.data.table);
        }

    }, [t1.data]);

    useEffect(() => {
        if(!t1.loadingInativacao){
            getT1Table(body);
        }
    }, [t1.loadingInativacao]);

    const getT1TableData = () => {
        getT1Table(body);
    }

    const handleCadastro = () => {
        clearT1Data();
        setModalCadastroOpen(true)
    }

    const handleEdicao = () => {
        if(idsSelecionado.length == 0) {
            alert('Selecione um Treinamento de 1 Ponto que gostaria de alterar');

        } else if(idsSelecionado.length > 1) {
            alert('Selecione apenas um Treinamento de 1 Ponto para alteração!');

        } else {
            getT1Data(idsSelecionado[0]);
            setModalCadastroOpen(true);
        }
    }

    const handleInativacao = () => {
        if(idsSelecionado.length == 0) {
            alert('Selecione os Treinamentos de 1 Ponto que gostaria de excluir');
        } else {
            setAlertConfirmacaoOpen(true);
            setAlertConfirmacaoTexto(EntidadesAcoes.T1_EXCLUSAO);
            setAlertConfirmacaoAcao(() => () => {
                onInativarT1(idsSelecionado);
                setAlertConfirmacaoOpen(false);
            })
        }
    }

    const changeTable = (__body: any) => {
        setBody({...__body});
    }

    const handlePersistT1 = (edicao: boolean, t1: FormData) => {
        if(edicao) {
            setIdSelecionado([]);
            onUpdateT1(t1);
        } else {
            onSaveT1(t1);
        }
    }

    const handleCloseAndReload = () => {
        clearT1Data();
        setModalCadastroOpen(false);
        setIdSelecionado([]);
    }

    const unmountAlertConfirmacao = () => {
        setAlertConfirmacaoTexto('');
        setAlertConfirmacaoAcao(() => () => {})
        setAlertConfirmacaoOpen(false);
    }

    return (
        <div className="pageBox">
            <Loading loading={t1.loading || t1.loadingPersis} />
            <AlertaConfirmaAcao openDialog={alertConfirmacaoOpen} texto={alertConfirmacaoTexto} execAcao={() => alertConfirmacaoAcao()} cancelaAcao={() => unmountAlertConfirmacao()} />
            <ModalCadastroT1 
                modalCadastroOpen={modalCadastroOpen} 
                closeModal={() => handleCloseAndReload()}
                t1Data={t1.data.t1} 
                persist={handlePersistT1}
                id={idsSelecionado[0]}
                enviaNotificacao={(idCursoT1: any) => onNotificacaoT1(idCursoT1)}
            />
            <div className="menuLateral">
                <Typography variant="h6" noWrap component="div" sx={{
                    width: '100%'
                }} >
                    Ações
                    <AcaoMenu
                        onCadastro={handleCadastro} 
                        onEditar={handleEdicao} 
                        onInativar={handleInativacao} 
                    />
                </Typography>
            </div>
            <div className="table">
                <T1TableComponent
                    loading={t1.loadingTable} 
                    data={table} 
                    body={body}
                    onChange={changeTable} 
                    selection={idsSelecionado}
                    idSelectionChange={(idsArr: number[]) => setIdSelecionado(idsArr)}/>
            </div>
        </div>
    )
};

const mapStateToProps = (state: ApplicationState) => ({
    t1: state.t1,
    utils: state.utils
});
  
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({...T1Actions}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Treinamento1Ponto);
